export const configuracionColumnasVencimientos = [
    {
        name: "acreedor",
        field: "acreedor",
        label: "Acreedor",
        align: "left",
    },
    {
        name: "fecha_corte",
        field: "fecha_corte",
        label: "Fecha de corte",
        align: "left",
    },
    {
        name: "tipo_riesgo",
        field: "tipo_riesgo",
        label: "Tipo riesgo",
        align: "left",
    },
    {
        name: "saldo_deuda",
        field: "saldo_deuda",
        label: "Saldo deuda",
        align: "left",
    },
    {
        name: "valor_por_vencer",
        field: "valor_por_vencer",
        label: "Valor por vencer",
        align: "left",
    },
    {
        name: "no_devenga_intereses",
        field: "no_devenga_intereses",
        label: "No devenga Int",
        align: "left",
    },
    {
        name: "valor_vencido",
        field: "valor_vencido",
        label: "Valor vencido",
        align: "left",
    },
    {
        name: "demanda_judicial",
        field: "demanda_judicial",
        label: "Demanda judicial",
        align: "left",
    },
    {
        name: "cartera_castigada",
        field: "cartera_castigada",
        label: "Cartera castigada",
        align: "left",
    },
    {
        name: "tiempo_vencido_dias",
        field: "tiempo_vencido_dias",
        label: "Tiempo vencido días",
        align: "left",
    },
];
